import { Component, OnInit, Inject } from '@angular/core';
import { TableTradeService } from '@pg-app/client/client-dashboard/components/tables/table.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { format, getDaysInMonth } from 'date-fns';
import { SharingDataService } from '@pg-app/client/client-dashboard/components/tables/sharing-data.service';
import { ToastrService } from 'ngx-toastr';
import { UtilityService } from '@nttp/common-service/utility-service';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { TableCellTypes } from '@nttp/enum/table-cell-type-enum';
import { SortTypeEnum } from '@pg-app/shared/enums/sort-type.enum';
import { DownloadTypeEnum } from '@nttp/enum/download-type-enum';

@Component({
  selector: 'np-history-trade-detail',
  templateUrl: './history-trade-detail.component.html',
  styleUrls: ['./history-trade-detail.component.scss']
})

export class HistoryTradeDetailComponent implements OnInit {
  public rows: Array<any> = [];

  maxDate: Date;
  minDate: Date;
  showOrderColumn = false;

  todo = [
    'Confirmation',
    'Trade reference',
    'Creation date',
    'Trade type',
    'Sell currency and amount',
    'Rate',
    'Buy currency and amount',
    'Value date',
    'User',
  ];
  done = [];

  allColumns = [
    {
      title: 'Confirmation',
      name: 'confirmation',
      class: 'hyper-link',
      width: '120px'
    },
    {
      title: 'Trade reference',
      name: 'tradeNumber',
      width: '150px'
    },
    {
      title: 'Creation date',
      name: 'creationDate',
      type: TableCellTypes.Date,
      width: '120px'
    },
    {
      title: 'Trade type',
      name: 'tradeType',
      width: '110px'
    },
    {
      title: 'Sell currency and amount',
      name: 'sellAmount',
      class: 'text-right',
      width: '220px'
    },
    {
      title: 'Rate',
      name: 'rate',
      type: TableCellTypes.Rate,
      class: 'text-right',
      width: '150px'
    },
    {
      title: 'Buy currency and amount',
      name: 'buyAmount',
      class: 'text-right',
      width: '220px'
    },
    {
      title: 'Value date',
      name: 'valueDate',
      type: TableCellTypes.Date,
      width: '120px'
    },
    {
      title: 'User',
      name: 'user',
      width: '120px'
    }
  ];
  columns = this.allColumns;
  isLoading = true;

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
    }
  }

  constructor(
    private tableTradeService: TableTradeService,
    private sharingDataService: SharingDataService,
    public dialogRef: MatDialogRef<HistoryTradeDetailComponent>,
    private utilService: UtilityService,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.getTrades();
  }

  private downloadFileExcel(data: any, fileName: string) {
    this.utilService.downloadFile(data, fileName, DownloadTypeEnum.PDF);
  }

  public getTrades() {
    const startDate = new Date(this.dialogData.year, this.dialogData.month - 1, 1);
    const endDate = new Date(this.dialogData.year, this.dialogData.month - 1, getDaysInMonth(startDate));

    const tableData = {
      fromDate: format(
        startDate < this.sharingDataService.startDate ? this.sharingDataService.startDate : startDate,
        'YYYYMMDD'
      ),
      toDate: format(endDate > this.sharingDataService.endDate ? this.sharingDataService.endDate : endDate, 'YYYYMMDD'),
      state: this.dialogData.state,
      isExportExcel: false,
      sortName: 'CreationDate',
      sortType: SortTypeEnum.Desc,
      getAll: true
    };
    this.tableTradeService.getTradeByState(tableData).subscribe(
      response => {
        const data = response?.trades || [];
        if (data.length > 0) {
          data.forEach(item => {
            item.sellAmount = this.replaceString(item.sellAmount);
            item.buyAmount = this.replaceString(item.buyAmount);
            item.confirmation = `<span class="btn-action"> Download </span>`;
          });
        }
        this.rows = data;
        this.isLoading = false;
      },
    );
  }

  downloadOriginalTrade(tradeDetail) {
    if (tradeDetail.column === 'confirmation') {
      const params = {
        leadId: null,
        tradeNumber: tradeDetail.row.number
      };
      this.tableTradeService.downloadPDF(params).subscribe(
        data => {
          const fileName = `Trade_${tradeDetail.row.tradeNumber}.pdf`;
          this.downloadFileExcel(data, fileName);
        }
      );
    }
  }

  public replaceString(value: any) {
    if (!value || value.toString().trim() === '') {
      return;
    }
    const combine = value.split(' ');
    combine[1] = this.utilService.replaceValue(combine[1]);
    return combine.join(' ');
  }

  orderColumn(value) {
    this.showOrderColumn = value;
  }

  reOrder() {
    this.isLoading = true;
    let newColumns = [];
    this.todo.forEach(item => {
      newColumns = newColumns.concat(this.allColumns.find(p => p.title === item));
    });
    this.columns = newColumns;
    this.showOrderColumn = false;
    this.isLoading = false;
  }

  close() {
    this.dialogRef.close();
  }
}
